<template>
  <div
    style="background: var(--bg-surface); min-height: 100vh; height: auto; background-size: cover; padding-bottom: 15rem; background-attachment: fixed;"
  >
    <!-- <img src="/build/assets/img/brand/khit_thit.jpg" alt="" /> -->
    <!-- <div class="col-12 d-flex my-0">
      <img
        class="mx-auto"
        src="https://cdn.gold549.com/build/assets/img/brand/logo.png"
        alt=""
        style="width: 120px; height: 120px; margin-top: -22px"
      />
    </div> -->

    <Sticky>
      <div>
        <NavBar />
        <div class="home-banner col-12 px-2 pt-2">
          <b-carousel
            id="carousel-1"
            class="home-banner__carousel"
            :interval="4000"
            controls
            fade
          >
            <b-carousel-slide>
              <template #img>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  style="width: 100%; height: 100%; object-fit: cover;"
                >
                  <source
                    src="https://storage.googleapis.com/spacetech2/ys/b1.mp4"
                    type="video/mp4"
                  >
                </video>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  style="width: 100%; height: 100%; object-fit: cover;"
                >
                  <source
                    src="https://storage.googleapis.com/spacetech2/ys/b2.mp4"
                    type="video/mp4"
                  >
                </video>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  style="width: 100%; height: 100%; object-fit: cover;"
                >
                  <source
                    src="https://storage.googleapis.com/spacetech2/ys/b3.mp4"
                    type="video/mp4"
                  >
                </video>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  style="width: 100%; height: 100%; object-fit: cover;"
                >
                  <source
                    src="https://storage.googleapis.com/spacetech2/ys/b4.mp4"
                    type="video/mp4"
                  >
                </video>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <video
                  autoplay
                  muted
                  loop
                  playsinline
                  style="width: 100%; height: 100%; object-fit: cover;"
                >
                  <source
                    src="https://storage.googleapis.com/spacetech2/ys/b5.mp4"
                    type="video/mp4"
                  >
                </video>
              </template>
            </b-carousel-slide>
            <b-carousel-slide>
              <template #img>
                <img
                  src="@/assets/b6.jpg"
                  alt=""
                  class="home-banner__media"
                >
              </template>
            </b-carousel-slide>
          </b-carousel>
        </div>

        <div class="home-notice-bar col-12 d-flex px-3 mx-auto">
          <i class="fas fa-volume-up my-auto text-white pr-2 home-notice-bar__icon"></i>
          <NoticeBar
            class="col-lg-12 col-12 mx-0 px-0 mx-auto notice-bar"
            scrollable
            :text="websiteInfo.noticeText"
            v-if="!threedData.embedded_link && !threedData.isLive"
          />
          <!-- websiteInfo[0]?.noticeText  -->
        </div>

        <!-- <div class="my-3 text-center py-2" style="background: #F4DC83; font-weight: 900; color: black;">
          TOP GAMES
        </div> -->
      </div>
    </Sticky>


    <div class="cards-container-mobile">
      <div
        class="container-fluid justify-content-end px-0 d-flex pt-0"
        style="position: relative;"
      >
        <!-- <div class="col-12"> -->

        <div
          class="pr-0 mx-0 pl-2 index_left sidebar"
          style="overflow-y: auto; margin-bottom: 25rem; height: 90vh; width: 20%; position: absolute;"
        >
          <div style="height: 130vh;">
            <ul class="nav nav-pills game-nav">
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                  style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('hot');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/HOT.avif"
                    class="mx-auto p-0 m-0 pr-1"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mt-1 mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                  >{{
                    $t('home.hot') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('buffalo');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/BUFFALO.avif"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <!-- <img v-show="$store.state.sideNav === 'buffalo'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                  >{{
                    $t('home.buffalo') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'card' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('card');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/SHANKOEMEE.avif"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <!-- <img v-show="$store.state.sideNav === 'card'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/0c75648c-b244-4972-a288-6e11ca52f100/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'card' ? 'active' : ''"
                  >{{
                    $t('home.card') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                  style="padding-top: 0.6rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('slot');"
                >
                  <!-- <img v-show="$store.state.sideNav !== 'slot'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/75b1ab42-51bc-408a-56cd-85ec16303d00/public" class="mx-auto p-0 ml-2" style="cursor: pointer; width: 3rem;"> -->
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/SLOT.avif"
                    class="mx-auto p-0 ml-2 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                  >{{
                    $t('home.slot') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2"
                  :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                  style="padding-top: 1rem !important;width: 90%; height: 6rem; border-radius: 10px;"
                  @click="changeSideNav('fishing');"
                >
                  <!-- <img v-show="$store.state.sideNav !== 'fishing'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/1c9d8b71-8e10-4dbc-a3f4-6eb1b6631b00/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 3rem;"> -->
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/FISHING.avif"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 2.5rem;"
                  >
                  <span
                    class="mt-1 mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                  >{{ $t('home.fishing') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('casino');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/LIVE-CASINO.avif"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 3rem;"
                  >
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                  >{{
                    $t('home.casino') }}</span>
                </div>
              </li>
              <li class="nav-item d-flex mt-2">
                <div
                  class="side-nav-icon d-flex flex-column p-2 pt-0"
                  :class="$store.state.sideNav === 'football' ? 'active' : ''"
                  style="padding-top: 0.8rem !important; width: 90%; height: 5.5rem; border-radius: 10px;"
                  @click="changeSideNav('football');"
                >
                  <img
                    src="https://storage.googleapis.com/spacetech2/ys/SPORT.avif"
                    class="mx-auto p-0 m-0 pulse"
                    style="cursor: pointer; width: 3rem;"
                  >
                  <span
                    class="mx-auto side-nav-icon-text"
                    :class="$store.state.sideNav === 'football' ? 'active' : ''"
                  >{{
                    $t('home.football') }}</span>
                </div>
              </li>
              <!-- <li class="nav-item d-flex mt-2">
                    <div class="side-nav-icon d-flex flex-column p-2 pt-0" :class="$store.state.sideNav === 'download' ? 'active': ''" style="padding-top: 0.8rem !important; width: 90%; height: 5rem; border-radius: 10px;" @click="changeSideNav('download');">
                      <img v-show="$store.state.sideNav !== 'download'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 2rem;">
                      <img v-show="$store.state.sideNav === 'download'" src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/cd795506-1111-41aa-135a-561223d42600/public" class="mx-auto p-0 m-0" style="cursor: pointer; width: 2rem;">
                      <span class="mx-auto side-nav-icon-text" :class="$store.state.sideNav === 'download' ? 'active': ''">{{$t('home.download')}}</span>
                    </div>
                  </li> -->
            </ul>
          </div>
        </div>

        <div
          class="index_rightbar mr-0 pl-0 col-10 pl-2 pr-1"
          id="index_rightbar"
          style="height: 90vh; overflow-y: scroll; position: absolute;"
        >
          <div
            :style="($store.state.sideNav === 'slot' || $store.state.sideNav === 'hot') ? 'height: 400vh' : 'height: 150vh'"
          >
            <div
              class="tab-content game  px-2"
              style="min-height: 50vh; border-radius: 20px; height: auto; padding-bottom: 30rem;"
            >

              <div
                class="mx-1 mt-0"
                :class="$store.state.sideNav === 'hot' ? 'active' : ''"
                v-show="$store.state.sideNav === 'hot'"
              >
                <div class="hot-games-wrapper">
                  <div
                    v-for="section in hotSections"
                    :key="section.key"
                    class="hot-section"
                  >
                    <div class="hot-section-header">
                      <h3 class="hot-section-title">{{ $t(section.titleKey) }}</h3>
                      <div class="hot-section-line"></div>
                    </div>

                    <div class="hot-game-container d-flex flex-wrap">
                      <div
                        v-for="(game, index) in section.games"
                        :key="`${section.key}-${game.gameID}-${index}`"
                        class="hot-game-card col-3 p-0"
                        @click="handleHotGameClick(game)"
                      >
                        <div class="hot-game-card__image-wrap">
                          <img
                            v-if="game.hot"
                            class="hot-game-card__badge"
                            src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/dae6345e-9f8a-471a-a361-ce0d318af400/public"
                            alt="hot"
                          >
                          <img
                            :src="imageLinkGenerate(game.gameID, game.provider, game)"
                            :alt="game.gameName"
                            class="hot-game-card__image"
                          >
                        </div>
                        <span class="hot-game-card__name">{{ game.gameName }}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>



              <!-- <div class="mx-1" :class="this.$store.state.sideNav === 'vs' ? 'active' : ''" v-show="this.$store.state.sideNav === 'vs'">
                    <img src="https://imagedelivery.net/HPdN1Z_Ube9zTuVFQK-tGg/723ca88a-6cf0-406b-d7b3-a93d023f6f00/public" alt="slot" style="cursor: pointer; width: 103%; margin-left: -0.4rem; height: auto;" @click="gameInit('CockFight')">
                  </div> -->

              <div
                :class="$store.state.sideNav === 'skm' ? 'active' : ''"
                v-if="$store.state.sideNav === 'skm'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="skm"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchShanKoMeeData(5)"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'bgy' ? 'active' : ''"
                v-if="$store.state.sideNav === 'bgy'"
              >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%9C%E1%80%B0%E1%80%9E%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(0)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%82%E1%80%BB%E1%80%B0%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(1)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%85%E1%80%AE%E1%80%94%E1%80%AE%E1%80%9A%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(2)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%B1%E1%80%AC%E1%80%B7%E1%80%85%E1%80%BA.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(3)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%99%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(4)"
                >
                <img
                  class="mx-1 my-1"
                  src="https://cdn.myanmarshankoeme.com/build/assets/img/bf688/%E1%80%98%E1%80%AE%E1%80%9C%E1%80%AE%E1%80%9A%E1%80%B6%E1%80%94%E1%80%AC.png"
                  alt="bgy"
                  style="cursor: pointer; width: 47.5%; height: auto;"
                  @click="fetchBugyee(5)"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'card' ? 'active' : ''"
                v-if="$store.state.sideNav === 'card'"
                class="pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/SKM-CARD.avif"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="changeSideNav('skm')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/BUU-GYI.avif"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="changeSideNav('bgy')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/FOREST-PARTY.avif"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="fetchForestData()"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/GLGL.avif"
                  alt="card"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="fetchGaloneData()"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'buffalo' ? 'active' : ''"
                v-if="$store.state.sideNav === 'buffalo'"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/A-BUFFALO.avif"
                  alt="skm"
                  class="px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="$router.push('/user/slots?provider=Buffalo')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'fishing' ? 'active' : ''"
                v-if="$store.state.sideNav === 'fishing'"
                class="pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/FC-FISHING.avif"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=FaChai')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/JILI-FISHING.avif"
                  alt="skm"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/AW-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/2J-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=2J')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/BNG-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=BNG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/BT-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/JDB-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/R88-FISHING.avif"
                  class="col-12 px-1 py-1 px-0 mx-0"
                  alt="skm"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/fishing?provider=Rich88')"
                >

              </div>

              <div
                :class="$store.state.sideNav === 'slot' ? 'active' : ''"
                v-if="$store.state.sideNav === 'slot'"
                class="pb-2 mx-0 px-0 d-flex flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/PP-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Pragmatic')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/PG-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=PGSoft')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/JILI-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Jili')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/2J-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=2J')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/5G-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=5G')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/LIVE22-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Live22')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/VA-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=VA')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/FC-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=FaChai')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/HD-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=HotDog')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/ACE-WIN-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=AceWin')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/JDB-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=JDB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/BT-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=BTG')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/PS-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Playstar')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/R-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Rich')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/R88-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=Rich88')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/VA-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=VA')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/YB-SLOT.avif"
                  alt="skm"
                  class="col-6 px-1 py-1 px-0 mx-0"
                  style="cursor: pointer; height: auto;"
                  @click="$router.push('/user/slots?provider=YellowBat')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'football' ? 'active' : ''"
                v-if="$store.state.sideNav === 'football'"
                class="d-flex justify-content-between flex-wrap"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/AFB.avif"
                  alt="football"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 49%; height: auto;"
                  @click="gameInitSport('AFBSport', 'AFB Sport')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/UMBET.avif"
                  alt="football"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 49%; height: auto;"
                  @click="gameInitSport('UMBET', 'UMBET')"
                >
              </div>

              <div
                :class="$store.state.sideNav === 'casino' ? 'active' : ''"
                v-if="$store.state.sideNav === 'casino'"
              >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/PP-CASINO.avif"
                  alt="casino"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="gameInitCasino('PP Live')"
                >
                <!-- <img
                  src="https://storage.googleapis.com/spacetech2/ys/SEXY-CASINO.avif"
                  alt="casino"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="gameInitCasino('Sexy')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/YB-CASINO.avif"
                  alt="casino"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="gameInitCasino('YB')"
                >
                <img
                  src="https://storage.googleapis.com/spacetech2/ys/BG-CASINO.avif"
                  alt="skm"
                  class="my-2 px-0 mx-0"
                  style="cursor: pointer; width: 100%; height: auto;"
                  @click="gameInitCasino('BG')"
                > -->
              </div>

              <div
                :class="$store.state.sideNav === 'download' ? 'active' : ''"
                v-if="$store.state.sideNav === 'download'"
              >
                <div class="gwrap_1 pb-3">
                  <h4 class="text-center text-dark mt-3">{{ $t('home.you_download') }} <br> {{
                    $t('home.on_any_platform') }}
                  </h4>
                  <a
                    href="https://backapi.melonzeed.vip/api/app/download/android"
                    download="melonzeed.apk"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/android-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto;"
                    >
                  </a>
                  <a
                    href="https://backapi.melonzeed.vip/api/app/download/ios"
                    download="melonzeed.mobileconfig"
                  >
                    <img
                      src="https://cdn.gold549.com/build/assets/img/brand/ios-download.png"
                      alt="slot"
                      style="cursor: pointer; width: 50%; height: auto; margin-top: 0.1rem;"
                    >
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <van-overlay :show="isLoading">
      <div
        class="wrapper"
        @click.stop
      >
        <van-loading
          type="spinner"
          color="#ffffff"
          class="mx-auto"
        />
      </div>
    </van-overlay>

    <!-- <LiveChatWidget license="18638211" v-if="testing"/> -->

    <div class="col-4">
      <div
        class="modal fade"
        id="limit"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-form"
        @click="hideLimit()"
      >
        <div
          class="modal-dialog modal- modal-dialog-centered"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-body my-5 mx-3 text-center">
              <span class="text-danger text-lg">
                <b>အထူးသတိပြုရန်။</b> <br><br>
              </span>
              <span>{{ limitText }}</span>
              <br><br> <span class="text-dark text-sm">
                <button
                  class="btn btn-danger"
                  @click="gameInit(desiredGame)"
                >
                  {{
                    $store.state.language === "en"
                      ? "Play The Game"
                      : "ဂိမ်းဆော့မည်။"
                  }}
                </button>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>
<script>
import NavBar from '@/layouts/NavBar.vue';
import { NoticeBar, Dialog, Toast, Sticky } from 'vant';
import { mapActions } from 'vuex';
import { LiveChatWidget } from '@livechat/widget-vue';
import { gameImageUrl } from '@/libs/gameImageUrl';
import { openGameInIframe } from '@/libs/openGameInIframe';

export default {
  components: { NoticeBar, Sticky, LiveChatWidget },
  data() {
    return {
      testing: true,
      isLoading: false,
      twoDdata: {},
      twoDHistories: {},
      threeDHistories: {},
      threedData: {},
      websiteInfo: {
        home_banners: {}
      },
      isLogged: false,
      hotGames: [],
      limitText: '',
      desiredGame: null,
    };
  },
  computed: {
    hotSections() {
      const excludeSpade = (games) =>
        (games || []).filter((game) => game.provider !== 'Spade');

      return [
        {
          key: 'buffaloGames',
          titleKey: 'home.popular_buffalo_games',
          games: excludeSpade(this.hotGames.buffaloGames),
        },
        {
          key: 'slotGames',
          titleKey: 'home.popular_slot_games',
          games: excludeSpade(this.hotGames.slotGames),
        },
        {
          key: 'fishingGames',
          titleKey: 'home.popular_fishing_games',
          games: excludeSpade(this.hotGames.fishingGames),
        },
        {
          key: 'arcadeGames',
          titleKey: 'home.popular_arcade_games',
          games: excludeSpade(this.hotGames.arcadeGames),
        },
      ];
    },
  },
  destroyed() {
    this.testing = false;
  },
  methods: {
    async fetchForestData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/forest-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = res?.data?.data ?? res?.data ?? {};
        const apiDescription =
          data?.description ??
          res?.data?.description ??
          data?.message ??
          res?.data?.message ??
          '';
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();

        if (gameUrl) {
          openGameInIframe(this.$router, this.$store, gameUrl, {
            gameName: 'Forest',
            provider: 'Buffalo',
            backRoute: '/home',
          });
        } else {
          Dialog.alert({
            message: apiDescription,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchGaloneData() {
      // if(this.$store.state.authUser.game_balance < 1000) {
      //   this.alertBoxForLimit();
      //   return false;
      // }
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push("/auth/login");
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get("/galone-data", {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.game_balance,
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        });

        const data = res?.data?.data ?? res?.data ?? {};
        const apiDescription =
          data?.description ??
          res?.data?.description ??
          data?.message ??
          res?.data?.message ??
          '';
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();

        if (gameUrl) {
          openGameInIframe(this.$router, this.$store, gameUrl, {
            gameName: 'Galone',
            provider: 'Buffalo',
            backRoute: '/home',
          });
        } else {
          Dialog.alert({
            message: apiDescription,
            confirmButtonText:
              this.$store.state.language === "en"
                ? "Go Back"
                : "နောက်သို့ပြန်သွားမည်။",
          });
        }

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async gameInitCasino(game) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            provider: game
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const gameUrl = res.data?.data?.gameUrl;
        if (!gameUrl) {
          this.isLoading = false;
          return;
        }

        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: game,
          provider: 'Live Casino',
          backRoute: '/home',
        });

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        // this.$router.go();
      }
    },

    async gameInitSport(provider, displayName = provider) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.isLoading = false;
          this.$router.push('/auth/login');
          return;
        }

        const res = await axios.get('/games/url', {
          params: { provider },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const gameUrl = res.data?.data?.gameUrl;
        if (!gameUrl) {
          this.isLoading = false;
          return;
        }

        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: displayName,
          provider: displayName,
          backRoute: '/home',
        });

        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
      }
    },
    hideLimit() {
      $('#limit').modal('hide');
    },
    showAlertBox(game) {
      if (game.provider === 'PGSoft') this.limitText = 'PG Soft တွင် 1K unit သည် 1,000 ကျပ်နှင့်ညီမျပါသည်။';
      else if (game.provider === 'FaChai') this.limitText = 'FaChai Provider တွင် 1 unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      // else this.limitText = '5G Provider တွင် 1K unit သည် 100 ကျပ်နှင့်ညီမျပါသည်။';
      $('#limit').modal('show');
      this.desiredGame = game;
    },

    async gameInit(game) {
      try {
        this.$store.commit('setLoading', true);
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const res = await axios.get('/games/url', {
          params: {
            gameID: game.gameID,
            provider: game.provider
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const gameUrl = res.data?.data?.gameUrl;
        if (!gameUrl) {
          this.$store.commit('setLoading', false);
          return;
        }

        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: game.gameName,
          provider: game.provider,
          backRoute: '/home',
        });

        this.$store.commit('setLoading', false);
      } catch (error) {
        this.$store.commit('setLoading', false);
      }
    },

    handleHotGameClick(game) {
      if (game.provider === 'PGSoft' || game.provider === 'FaChai') {
        this.showAlertBox(game);
        return;
      }
      this.gameInit(game);
    },

    imageLinkGenerate(gameId, type, game = null) {
      return gameImageUrl(gameId, type, game);
    },
    scrollToElement() {
      const container = this.$el.querySelector('.index_rightbar');
      // Scroll to the target element within the container
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
    async fetchBetGame(game = null, link = null) {
      try {
        this.isLoading = true;

        if (game) {
          this.gameName = game
          this.gameLink = link
        }
        const res = await axios.get(`/${this.gameName}-data`, {
          params: {
            id: this.$store.state.authUser.name,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          }
        });
        const gameUrl = `https://${link}.vercel.app/?id=${this.$store.state.authUser.name}&passcode=${res.data.passcode}&exit=https%3A%2F%2F${window.location.host}/home`;
        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: game || this.gameName,
          provider: link,
          backRoute: '/home',
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    async fetchBugyee(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        const res = await axios.get('/bugyee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });

        const data = res?.data?.data ?? res?.data ?? {};
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();
        // console.log(res.data)
        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: 'Bugyee',
          provider: 'Card',
          backRoute: '/home',
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },

    async fetchShanKoMeeData(level = null) {
      try {
        this.isLoading = true;
        const authUser = await this.fetchUser();
        if (!authUser) {
          this.$router.push('/auth/login');
        }

        const amount = authUser.amount;
        if (level == 0 && amount < 1000) {
          this.limitText = "1,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 0 && amount > 100000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 1 && amount < 3000) {
          this.limitText = "3,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 1 && amount > 300000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 2 && amount < 5000) {
          this.limitText = "5,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 2 && amount > 500000) {
          this.limitText = "သတ်မှတ်ထားသော ငွေပမာဏထပ် ကျော်လွန်နေပါသည်။ သင့်လျော်သောအခန်းတွင်သာ ကစားပေးပါ။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        if (level == 3 && amount < 10000) {
          this.limitText = "10,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 4 && amount < 30000) {
          this.limitText = "30,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }
        if (level == 5 && amount < 50000) {
          this.limitText = "50,000 အောက်ရောက်နေပါသည်။ ငွေထပ်မံဖြည့်သွင်းပြီးမှ သည်အခန်းကို ဆော့လို့ရပါမည်။";
          $('#limit').modal('show');
          this.isLoading = false;
          return false;
        }

        // if(this.nickname && this.nickname !== ''){
        const res = await axios.get('/shankomee-data', {
          params: {
            id: this.$store.state.authUser.name,
            level,
            balance: this.$store.state.authUser.amount,
            info: {
              nickname: this.$store.state.authUser.user_name,
              profile: 3
            }
          },
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
        });
        const data = res?.data?.data ?? res?.data ?? {};
        let gameUrl =
          data.gameUrl ??
          data.game_url ??
          data.url ??
          res?.data?.gameUrl ??
          res?.data?.url ??
          '';
        gameUrl = String(gameUrl || '').trim();
        // console.log(res.data)
        openGameInIframe(this.$router, this.$store, gameUrl, {
          gameName: 'Shan Koe Mee',
          provider: 'Card',
          backRoute: '/home',
        });
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        console.log(error);
      }
    },
    // async gameInit(game) {
    //   try {
    //     this.isLoading = true;
    //     const authUser = await this.fetchUser();
    //     if (!authUser) {
    //       this.$router.push('/auth/login');
    //     }

    //     const res = await axios.get('/games/url', {
    //       params: {
    //         provider: game
    //       },
    //       headers: {
    //         Authorization: `Bearer ${localStorage.getItem('token')}`,
    //       },
    //     });

    //     window.open(res.data.data.gameUrl, "_self");
    //     // this.$store.commit('setIframeURL', res.data.data.gameUrl);
    //     // this.$store.commit('setIsCardGame', false);
    //     // this.$router.push('/iframeURL');

    //     this.isLoading = false;
    //   } catch (error) {
    //     this.isLoading = false;
    //     // this.$router.go();
    //   }
    // },
    changeSideNav(para) {
      // this.sideNav = para;
      this.$store.commit('updateSideNav', para);
      this.scrollToElement()
    },
    ...mapActions(['logoutUser', 'fetchUser']),
    async redirectRoute(path, query = null) {
      try {
        console.log('query', query)
        if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },

    logout() {
      Dialog.confirm({
        title:
          this.$store.state.language === 'en'
            ? 'Are you sure to log out?'
            : 'ထွက်မှာ သေချာပါသလား?',
        cancelButtonText:
          this.$store.state.language === 'en' ? 'Cancel' : 'မထွက်တော့ပါ',
        confirmButtonText:
          this.$store.state.language === 'en' ? 'Sure' : 'သေချာပြီ',
      })
        .then(async () => {
          await this.logoutUser();
          this.$router.push('/auth/login');
          Toast.success(
            this.$store.state.language === 'en' ? 'Logged out!' : 'ထွက်ပြီးပြီ'
          );
        })
        .catch(() => { });
    },
    async redirectRoute(path, query = null) {
      try {
        if (path === 'tip') {
          const text = this.$store.state.language === 'en'
            ? 'This feature is not support yet.'
            : 'ယခုအချိန်တွင် အသုံးပြုလို့မရနိုင်သေးပါ။';
          Dialog.alert({
            message: text,
            confirmButtonText:
              this.$store.state.language === 'en'
                ? 'Okay'
                : 'Okay',
          }).then(() => {
            // on close
          });
        } else if (query) {
          this.$router.push({ path, query });
        } else {
          this.$router.push(path);
        }
      } catch (error) {
        console.log(error);
      }
    },
    threedDrawDateFormat(date) {
      return moment(date).format('ll');
    },
    async fetchTwoDdata() {
      try {
        const res = await axios.get('/2d/data');
        this.isLive = res.data.data[0].isLive;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchWebsiteData() {
      try {
        const res = await axios.get('/website-infos');
        this.websiteInfo = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchThreedDdata() {
      try {
        const res = await axios.get('/3d/data');
        this.threedData = res.data.data[0];
      } catch (error) {
        console.log(error);
      }
    },
    async fetchHotGames() {
      try {
        const res = await axios.get('/hot-games');
        this.hotGames = res.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    async fetchTwoThreeDHistories() {
      try {
        const twoDres = await axios.get('/twod_history');
        const threeDres = await axios.get('/threed_history');
        this.twoDHistories = twoDres.data.data;
        this.threeDHistories = threeDres.data.data;
      } catch (error) {
        console.log(error);
      }
    },
    // Function to load the Tawt.io chat widget
    // loadTawkChat() {
    //   console.log('here1')
    //   if (!document.getElementById('tawk-io-chat')) {
    //     console.log('here2')
    //     var Tawk_API = Tawk_API || {}, Tawk_LoadStart = new Date();

    //     // Dynamically add the script to load Tawt.io
    //     var s1 = document.createElement("script");
    //     var s0 = document.getElementsByTagName("script")[0];
    //     s1.async = true;
    //     s1.id = 'tawk-io-chat';
    //     s1.src = 'https://embed.tawk.to/66ed95584cbc4814f7dc1919/1i880up29';
    //     s1.charset = 'UTF-8';
    //     s1.setAttribute('crossorigin', '*');
    //     s0.parentNode.insertBefore(s1, s0);

    //     // Apply custom styles when the widget loads
    //     Tawk_API.onLoad = () => {
    //       this.applyCustomStyles();
    //       setInterval(this.applyCustomStyles, 1000);
    //     };
    //   }
    // },
    // Function to apply custom styles to the Tawk.to iframe
    applyCustomStyles() {
      var tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.style.bottom = '7rem'; // Adjust this as needed
        tawkIframe.style.left = '1rem';
        tawkIframe.style.right = '0rem';
      }
    },
    // Function to remove the Tawt.io script and widget
    removeTawkChat() {
      const tawkScript = document.getElementById('tawk-io-chat');
      if (tawkScript) {
        tawkScript.remove(); // Remove the script tag
      }

      // Remove the Tawk.to iframe widget
      const tawkIframe = document.querySelector('iframe[title="chat widget"]');
      if (tawkIframe) {
        tawkIframe.remove();
      }
    }
  },
  async mounted() {
    this.$store.commit('setLoading', true);
    await this.fetchWebsiteData();
    await this.fetchHotGames();
    this.$store.commit('setLoading', false);
  },
  beforeDestroy() {
    this.removeTawkChat();
  }
};
</script>
<style scoped>
.hot-games-wrapper {
  padding: 0 0.15rem;
}

.hot-section {
  margin-bottom: 1.5rem;
}

.hot-section-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
  padding: 0 0.15rem;
}

.hot-section-title {
  color: var(--text-gold);
  font-size: 0.95rem;
  font-weight: 600;
  margin: 0;
  white-space: nowrap;
}

.hot-section-line {
  flex: 1;
  height: 1px;
  background: linear-gradient(90deg, var(--border-gold), transparent);
}

.hot-game-card {
  cursor: pointer;
  margin-bottom: 12px;
  padding: 0 4px !important;
}

.hot-game-card__image-wrap {
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: var(--bg-card);
  box-shadow: rgba(0, 0, 0, 0.3) 0 2px 8px;
  aspect-ratio: 3 / 4;
}

.hot-game-card__image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
  display: block;
}

.hot-game-card__badge {
  position: absolute;
  top: 2px;
  right: 2px;
  width: 22px;
  height: auto;
  z-index: 2;
}

.hot-game-card__name {
  display: block;
  padding-top: 0.4rem;
  font-size: 0.68rem;
  color: var(--text-primary);
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  font-weight: 500;
}

.hot-game-card:active .hot-game-card__image-wrap {
  transform: scale(0.97);
  transition: transform 0.1s ease;
}

.pulse {
  -webkit-animation-name: pulse;
  animation-name: pulse;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}

@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }

  50% {
    -webkit-transform: scale3d(1.05, 1.05, 1.05);
    transform: scale3d(1.05, 1.05, 1.05);
  }

  100% {
    -webkit-transform: scale3d(1, 1, 1);
    transform: scale3d(1, 1, 1);
  }
}

.side-nav-icon-text {
  /* color: #A80000; */
  font-size: 0.9rem;
  /* color: #382618; */
}

.side-nav-icon {
  position: relative;
  cursor: pointer;
  overflow: hidden;
  font-weight: 600;
  color: var(--text-primary) !important;
  background: var(--bg-card);
  /* background: #2b2c2e; */
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #000000 0 0 0 inset; */
  box-shadow: rgba(99, 99, 99, 0.2) 0px 2px 8px 0px;
}

.side-nav-icon.active {
  /* background: #A80000; */
  /* background: radial-gradient(circle at 10% 20%, rgb(241, 121, 226) 0%, #DD4DD1 86.8%); */
  background: var(--gradient-primary);
  color: var(--color-on-primary) !important;
  /* box-shadow: rgba(40, 40, 40, 0.4) 0 2px 4px, rgba(40, 40, 40, 0.4) 0 7px 13px -3px, #01ff3c 0 -3px 0 inset; */
}

.side-nav-icon-text.active {
  color: white !important;
}

.sidebar {
  position: fixed;
  /* top: 23.5rem; */
  left: 0;
  height: 55vh;
  padding-bottom: 50px;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
  overflow-y: auto;
}

.index_rightbar {
  padding: 0px 10px;
  overflow-y: scroll;
  height: 55vh;
  scrollbar-width: none;
  /* For Firefox */
  -ms-overflow-style: none;
  /* For Internet Explorer and Edge */
}

.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.detail-button {
  appearance: none;
  background-color: transparent;
  border: 2px solid var(--color-primary);
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  color: var(--color-primary-light);
  cursor: pointer;
  display: inline-block;
  font-family: Roobert, -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol";
  font-size: 0.9rem;
  font-weight: 450;
  line-height: normal;
  margin: 0;
  min-height: 15px;
  min-width: 0;
  outline: none;
  padding: 5px 10px;
  text-align: center;
  text-decoration: none;
  transition: all 300ms cubic-bezier(.23, 1, 0.32, 1);
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  width: 100%;
  will-change: transform;
}

.detail-button:disabled {
  pointer-events: none;
}

.detail-button:hover {
  color: var(--color-on-primary);
  background: var(--gradient-primary);
  box-shadow: rgba(0, 0, 0, 0.25) 0 8px 15px;
  transform: translateY(-2px);
}

.detail-button:active {
  box-shadow: none;
  transform: translateY(0);
}

.nav-pills.game-nav {
  padding-right: 5px;
}

.nav-pills .nav-link {
  border-radius: 10px !important;
  margin-bottom: 5px;
  /* padding: 10px; */
  font-size: 10px !important;
  text-align: center;
  color: #ffffff;
  /* background: linear-gradient(#aa9ace, var(--color-primary)); */
}

.nav-pills:not(.nav-pills-circle) .nav-item {
  padding-right: 0;
  margin-bottom: 0;
  width: 100px;
}

.nav-pills .nav-link img {
  width: 18px !important;
  /* margin-right: 10px; */
  padding-bottom: 4px;
}

.nav-pills .nav-link.active,
.nav-pills .show>.nav-link {
  color: #fff !important;
  background: var(--gradient-primary);
}

.nav {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none;
}

.tab-content.game a img {
  /* box-shadow: 0px 3px 14px -5px rgba(0, 0, 0, 0.4); */
  border-radius: 21px;
  margin-bottom: 10px;
  width: 100%;
}

.tab-content.game {
  padding-left: 3px;
}

.tab-content>.tab-pane {
  display: none;
  padding-right: 3px;
}

.tab-content>.active {
  display: block;
}


.css-38745a {
  margin: 0px;
  line-height: 1.5;
  font-size: 12px;
  font-family: NotoSansMyanmar;
  font-weight: 500;
}

.css-17h40hp {
  margin: 0px;
  line-height: 1.5;
  font-size: 14px;
  font-family: NotoSansMyanmar;
  font-weight: 700 !important;
}

.card {
  cursor: pointer;
  border-radius: 10px !important;
}

.home-banner {
  width: 100%;
}

.home-banner__carousel {
  width: 100%;
  overflow: hidden;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.45);
  background: var(--bg-card);
}

.home-banner__carousel ::v-deep .carousel-inner {
  position: relative;
  height: 140px;
}

.home-banner__carousel ::v-deep .carousel-item,
.home-banner__carousel ::v-deep .carousel-item.active {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.home-banner__carousel ::v-deep .carousel-item img,
.home-banner__media {
  width: 100%;
  height: 100%;
  object-fit: fill;
  object-position: center;
  display: block;
  border-radius: 0;
}

.home-banner__carousel ::v-deep .carousel-control-prev,
.home-banner__carousel ::v-deep .carousel-control-next {
  width: 10%;
  opacity: 0.7;
}

.home-banner__carousel ::v-deep .carousel-control-prev-icon,
.home-banner__carousel ::v-deep .carousel-control-next-icon {
  width: 1.25rem;
  height: 1.25rem;
  background-color: rgba(0, 0, 0, 0.45);
  border-radius: 50%;
  background-size: 55%;
}

.home-notice-bar {
  z-index: 10;
  margin-top: 0.25rem;
  margin-bottom: 0.25rem;
  padding: 0.15rem 0.75rem;
  align-items: center;
  background: var(--bg-dark) !important;
  border-top: 1px solid var(--border-gold);
  border-bottom: 1px solid var(--border-gold);
}

.home-notice-bar__icon {
  font-size: 11px;
  font-weight: 600;
}

.notice-bar {
  z-index: 1;
  font-size: 11px;
  color: var(--text-gold);
  background: transparent;
}

.home-notice-bar ::v-deep .van-notice-bar {
  height: 22px;
  line-height: 22px;
  padding: 0;
}

.twod-threed-cards {
  height: 200px;
}

.live-number {
  font-weight: bold;
  font-size: 25px;
}

.live-result {
  font-weight: bolder;
  font-size: 60px;
  animation-name: live-number-animation;
  animation-duration: 2s;
  animation-iteration-count: infinite;
}

.not-live-text {
  font-weight: bold;
  font-size: 24px;
}

.cards-container {
  display: flex;
  flex-wrap: wrap;
}

.card-body {
  padding: 0px !important;
}

.cards-container-mobile {
  display: none;
}

@keyframes live-number-animation {
  from {
    color: white;
  }

  to {
    color: var(--color-primary-light);
  }
}

/* @media (max-width: 768px) { */
/* .middle-container {
    padding-top: 0.1rem !important;
  } */
hr {
  margin-top: 0px;
  margin-bottom: 0px;
}

.main-wrapper {
  padding: 7px !important;
}

.live-number {
  font-weight: bold;
  font-size: 20px;
}

.live-result {
  font-weight: bolder;
  font-size: 37px;
}

.cards-container {
  display: none;
}

.cards-container-mobile {
  padding: 0px !important;
  margin-top: 5px !important;
  display: flex;
  flex-wrap: wrap;
}

.home-cards {
  padding-left: 10px;
  padding-right: 10px;
}

.card-body {
  padding: 0px !important;
}

.not-live-text {
  font-size: 18px;
  padding-left: 10px;
  padding-right: 10px;
}

.account-container-wrapper {
  width: auto;
  height: auto;
  border-radius: 10px;
  padding-left: 4px;
  padding-right: 4px;
  margin-top: 10px !important;
  margin-left: 10px;
  margin-right: 10px;
  color: var(--text-primary);
  background: var(--bg-card);
  box-shadow: var(--shadow-card);
}

.top-wrapper,
.bottom-wrapper {
  padding: 10px;
  width: 100%;
  display: flex;
}

.top-right,
.bottom-right {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: end;
}

.top-left,
.bottom-left {
  width: 50%;
  height: 100%;
  display: flex;
  justify-content: start;
}

/* } */
</style>
